"use client"
import SectionPage from "@/components/common/section-page";
import CardTitle from "@/components/common/card-title";
import {PaveScaleCard} from "@/components/common/pave-scale-card";

export default function Page() {

    return (
        <div className={"flex flex-col gap-6 pb-6"}>
            <CardTitle title={"Foires et Salons"}
                       backgroundImgSrc={"/images/actualites/foires-et-salons/baniere.jpeg"}/>

            {/* Flash Infos Content */}
            <SectionPage sectionType="2xl">
                <div className="gap-6 my-8">

                    <SectionPage sectionType="sm">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6 mb-6">
                            <PaveScaleCard title={"IFTM TOP RESA 2023: Côte d'Ivoire Tourisme au Rendez-vous de la Grande Messe"}
                                           buttonLabel={"Consulter"} className={"h-[400px] text-center"} link="/actualites/foires-et-salons/iftm"
                                           titleClassName={"font-playfair-display italic font-bold text-center"} />
                            <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] text-center"}
                                           link="/pdf-viewer/Dossier-de-Presse-Top-Resa-2023-ok-bonne-version.pdf"
                                           image={"/images/actualites/foires-et-salons/dossier-presse.png"}
                                           titleClassName={"font-playfair-display-italic text-xl"}/>
                        </div>
                    </SectionPage>
                </div>
            </SectionPage>
        </div>
    );
}
